// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { TooltipTypography } from '@/components/tooltip-typography';
import { SparsePerson } from '@/sparse/api/types';
import { Typography, TypographyProps } from '@mui/material';
import { DateTime } from 'luxon';

interface Props extends Pick<TypographyProps, 'color'> {
  /**
   * The last-updated timestamp, or null when unknown.
   */
  date: DateTime | null;

  /**
   * The person who made the update, named in the tooltip.
   */
  by?: SparsePerson;
}

/**
 * A table cell value for last-updated columns: the date with a dotted
 * underline whose tooltip carries the fully resolved timestamp and the
 * updating user's name.
 */
export function LastUpdatedDate(props: Props) {
  if (props.date === null) {
    return (
      <Typography variant="body2" color={props.color}>
        &mdash;
      </Typography>
    );
  }
  const resolved = props.date.toLocaleString(DateTime.DATETIME_FULL);
  const byName = props.by
    ? [props.by.firstName, props.by.lastName].filter(Boolean).join(' ').trim()
    : '';
  const tooltip = byName ? `${resolved} by ${byName}` : resolved;
  return (
    <TooltipTypography variant="body2" color={props.color} tooltip={tooltip}>
      {props.date.toLocaleString({ dateStyle: 'medium' })}
    </TooltipTypography>
  );
}
